<template>
  <transition name="modal">
    <div class="modal-mask" v-if="item.name">
      <div class="modal-wrapper" @click="close($event)">
        <div class="modal-container">
          <div class="modal-header">

            <h3>{{ item.name }}</h3>
            <button type="button" class="btn-close-modal" @click="close()">×</button>
          </div>
          <div class="modal-body">
            <div>
              <div class="catalog catalog_view_detail">
                <div class="catalog__product-info product product_view_card">
                  <div class="product__content-inner">
                    <div class="product__header-info">
                      <div class="product__options-info">
                        <span class="product__options-info-item">Код:
                          <vue-popper :id="item.id + '-xmlid'"
                                      :hint="'Копировать'" :hint-click="'Скопировано'" @hinted="copy">{{ item.code }}</vue-popper>
                        </span>
                          <span class="product__options-info-item">Артикул:
                          <vue-popper :id="item.id + '-vendorCode'"
                                      :hint="'Копировать'" :hint-click="'Скопировано'" @hinted="copy">{{ item.vendorCode }}</vue-popper>
                        </span>
                          <span class="product__options-info-item">Штрих-код:
                          <vue-popper :id="item.id + '-barcode'"
                                      :hint="'Копировать'" :hint-click="'Скопировано'" @hinted="copy">{{ item.barcode }}</vue-popper>
                        </span>
                      </div>
                      <product-statuses :item="item" v-if="user.isAuthorized"></product-statuses>
                    </div>
                    <div class="product__header-info">
                      <breadcrumbs :items="item.breadcrumbs" :name="item.name"></breadcrumbs>
                    </div>
                    <div class="product__header-info">
                      <a target="_blank" :href="item.url">{{ item.url }}</a>
                      <input type="text" id="url_copy" :value="item.url"
                             style="display: none;"/>
                      <span style="display: none;" class="btn-copy"
                            onclick="copy2Clipboard()">копировать</span><span class="res-copy"
                                                                              style="display: none;"></span>
                    </div>
                    <div class="product__picture">
                      <div class="product__badges" v-if="item.badge.length > 0">
                        <span class="product__badge" v-if="item.badge.includes('hit')">Хит</span>
                        <span class="product__badge" v-if="item.badge.includes('new')">Новинка</span>
                        <span class="product__badge" v-if="item.badge.includes('action')">Акция</span>
                      </div>
                      <div class="product__picture-slider js-slider-preview-product-withThumb">
                        <div class="product__picture-slider-main" data-slider="main">

                          <template v-if="item.images.large.length > 0">
                            <vue-swiper :images="item.images.large" :key="item.id"></vue-swiper>
                          </template>
                          <template v-else>
                            <div class="thumb-image img-content">
                              <img src="/img/empty-600.png">
                            </div>
                          </template>

                        </div>
                        <div class="product__picture-slider-thumbs">

                        </div>
                      </div>
                      <div class="product__to_favorite" @click="updateFavorite(item)">
                        <span class="icon"
                              :class="{'icon-heart': !item.favorite, 'icon-heart-full': item.favorite}"></span>
                      </div>
                    </div>
                    <div class="product__actions" v-if="!item.is_archive">
                      <div class="product__prices" v-if="user.isAuthorized">
                        <div class="product__price product__price_type_old" v-if="item.price.stock != item.price.price">
                          {{ Math.round(item.price.stock * item.step * 100) / 100  }} Р.
                          <span class="percent-badge percent-badge_theme_yellow percent-badge_size_xs product__price-percent ">
                            <span class="percent-badge__value">
                                          <vue-popper :id="item.id + '-el-percent'"
                                                      :hint="'Ваша перональная скидка на данную категорию товаров'">{{
                                              item.price.percent
                                            }}</vue-popper>
                            </span>
                          </span>
                        </div>
                        <div class="product__price">
                          {{ Math.round(item.price.price * item.step * 100) / 100   }} Р.
                        </div>
                      </div>
                      <div class="product__noreg-box" v-else>
                        <div class="product__noreg-box-text">
                          Видеть цены и покупать могут только зарегистрированные пользователи
                        </div>
                        <a :href="'/auth/?login=yes&backurl=' + back_url"
                           class="product__noreg-box-button button button_theme_primary_blue button_size_md">
                          <span class="button__text">Войти и купить</span>
                        </a>
                        <a :href="'/auth/?register=yes&backurl=' + back_url">Зарегистрироваться</a>
                      </div>
                      <div class="product__buy-action" v-if="user.isAuthorized">
                        <product-summary-controls :item="item" :productId="item.id" :v="item.dimensions.volume" :x="item.code"></product-summary-controls>
                      </div>
                    </div>
                    <div class="product__main-info">
                      <a class="product__name">
                        {{ item.name }}
                      </a>
                      <div class="product__options-group">
                        <ul class="product__options product__options_lists">
                          <li class="product__options-item"
                              v-if="item.dimensions.volume">
                            <span class="product__options-item-caption">Объем</span>
                            <span class="product__options-item-value">{{ item.dimensions.volume }} м³</span>
                          </li>
                          <li class="product__options-item"
                              v-if="item.dimensions.size">
                            <span class="product__options-item-caption">Размер(ГхШхВ)</span>
                            <span class="product__options-item-value">{{ item.dimensions.size }} см</span>
                          </li>
                          <li class="product__options-item"
                              v-if="item.dimensions.weight != ''">
                            <span class="product__options-item-caption">Вес (грамм)</span>
                            <span class="product__options-item-value">{{ item.dimensions.weight }}</span>
                          </li>
                          <li class="product__options-item"
                              v-if="item.dimensions.pack_size">
                            <span class="product__options-item-caption">Размер упак.(ГхШхВ)</span>
                            <span class="product__options-item-value">{{ item.dimensions.pack_size }} см</span>
                          </li>
                          <li class="product__options-item"
                              v-for="(pval, pkey) in item.properties"
                              v-if="isShowAllProps">
                            <span class="product__options-item-caption">{{ pkey }}</span>
                            <span class="product__options-item-value"
                                  v-if="pval.code=='TorgovayaMarka' || pval.code=='Litsenziya'">
                                      <a :href="pval.url"
                                         target="_blank">{{ pval.text }}</a>
                            </span>
                            <span class="product__options-item-value"
                                  v-else>{{ pval }}</span>
                          </li>
                          <li v-if="isShowAllProps && item.licenses.length > 0" class="product__options-item">
                            <span class="product__options-item-caption">Лицензии</span>
                            <span class="product__options-item-value"  style="display: grid;">
                                    <a v-for="(lval, lkey) in item.licenses" :href="lval.url" target="_blank">{{ lval.text }}</a>
                            </span>
                          </li>
                        </ul>
                        <a href="javascript:void(0);"
                           class="action-link action-link_default js-view-all-haracteristik"
                        >
                          <span class="action-link__text" @click="showAllProps()">{{ nameButton }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="catalog__description"
                     v-if="item.description.preview != '' || item.description.detail != ''">
                  <h3 class="catalog__description-title">Описание</h3>
                  <p v-if="item.description.preview != ''" v-html="item.description.preview"></p>
                  <p v-if="item.description.detail != ''" v-html="item.description.detail"></p>
                </div>

                <div class="product__action-link product__action-link_sertificat popup-image-gallery"
                     style="float: left; margin-right: 20px;" v-if="item.certificates.length > 0">
                  <a :href="item.certificates[0]" @click.prevent="showModalSertificate(item)"
                     class="product__action-link-text">
                    <span class="product__action-link-icon icon icon-sertificat"></span>
                    Сертификат
                  </a>
                </div>
                <div class="product__action-link product__action-link_sertificat popup-image-gallery"
                     v-if="item.youtube_id" style="position: unset;">
                  <!--<a target="_blank" :href="'https://www.youtube.com/watch?v=' + item.youtube_id"
                     class="popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video" title="Видео">
                    Видео <img src="/img/youtube.png" style="height: 25px;">
                  </a>-->

                  <a target="_blank"  @click.prevent="showModalYouTube(item)"
                     class="popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video" title="Видео">
                    Видео <img src="/img/youtube.png" style="height: 25px;">
                  </a>
                </div>
                <div class="product__action-link product__action-link_sertificat popup-image-gallery"
                     v-if="item.manual" style="position: unset;">
                  <a target="_blank" :href="'/upload/manuals/' + item.vendorCode + '.pdf'"
                     class="popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video" title="Инструкция">
                    Инструкция по сборке <img src="/img/pdf.png" style="height: 25px;">
                  </a>
                </div>


              <div style="width: 76vw;">
                <vue-swiper-products v-show="item && Object.keys(item).length > 0" :user="user" :items="item.analogues" :key="item.id" :item-id="item.id"></vue-swiper-products>
              </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a class="modal-default-button" @click="close()">
              Закрыть
            </a>
          </div>
        </div>
      </div>
    </div>
  </transition>

</template>
<script>
import VueSwiper from "./VueSwiper.vue";
import VuePopper from "./VuePopper.vue";
import eventBus from "./EventBus.vue";
import Breadcrumbs from "./Breadcrumbs.vue";
import ProductStatuses from "./ProductStatuses.vue";
import ProductSummaryControls from './ProductSummaryControls.vue';
import VueSwiperProducts from "./VueSwiperProducts.vue";
import axios from "axios";

export default {
  name: 'modalElement',
  data: function () {
    return {
      showModal: false,
      isShowAllProps: false,
      nameButton: 'Все характеристики',
      back_url: window.btoa(this.$route.path),
    }
  },
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    },
    user: {
      type: Object,
      default: function () {
        return {}
      }
    },
    cart: {
      type: Number,
      default: function () {
        return 0
      }
    }
  },
  watch:
  {
    'item.id': function(value){
      let vm = this;
      axios.post(
          '/api/analog',
              {
                'id': vm.item.id,
              },
              {
                headers: {
                  'content-type': 'application/json; charset=utf8',
                  'X-Requested-With': 'XMLHttpRequest',
                }
              }
      )
      .then(function (response) {
        if (response.status == 200) {
          let data = response.data;
           vm.item.analogues = data.result.analogues;
        }
      });
    }
  },
  methods: {
    close(event) {
      this.$emit('close', event);
    },
    updateFavorite: function(item) {
      eventBus.$emit('updateFavorite', {item: item});
    },
    showAllProps: function () {
      this.isShowAllProps = !this.isShowAllProps;
      if (this.isShowAllProps) {
        this.nameButton = 'Скрыть характеристики';
      } else {
        this.nameButton = 'Все характеристики';
      }
    },
    showModalSertificate(item) {
      this.isModalSertificateVisible = true;
      eventBus.$emit('showSertificate', {item: item});
    },
    showModalYouTube(item) {
      this.isModalSertificateVisible = true;
      eventBus.$emit('showYoutube', {item: item});
    },
    selectText: function(element) {
      let range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    copy: function (event) {
      if (navigator.clipboard != undefined) {
        let value = event.target.innerHTML;
        navigator.clipboard.writeText(value)
      } else {
        this.selectText(event.target);
        document.execCommand("copy");
      }
    },
  },
  components: {
    VueSwiper,
    VuePopper,
    Breadcrumbs,
    ProductStatuses,
    ProductSummaryControls,
    VueSwiperProducts
  }
};
</script>
<style scoped>
  .modal-mask {
    display: block;
    overflow: scroll;
  }
</style>